import styled from "styled-components";
import Button from "../../../../../components/Button";

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessIcon = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #d3f2d3;
  border: 1px solid #4ca154;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: #4caf50;
    width: 48px;
    height: 48px;
  }
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  color: #2d3436;
  margin: 0px;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: normal;
  color: #2d3436;
  margin: 0px;
  text-align: center;
`;

export const SmallText = styled.p`
  font-size: 12px;
  line-height: normal;
  color: #2d3436;
  margin: 0px;
  text-align: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const PrimaryButton = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
  width: 100%;
`;

export const SecondaryButton = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
  width: 100%;
`;
